/* eslint-disable no-restricted-syntax */
import {
  getInjectedPlugins,
  pipeInsertDataQuery,
  insertNode,
  ELEMENT_IMAGE,
} from '@udecode/plate';

import { getHeightAndWidthFromDataUrl } from 'utils/images';
import { createUploadStore } from './createUploadStore';
import { uploadFiles } from './uploadFiles';
import { renameFilesInFilelist } from './extractImage';

/**
 * Allows for pasting images from clipboard, uploading via drag n drop
 * and uploading via file explorer.
 */
export const withImageUpload = (
  editor,
  plugin,
) => {
  const { insertData } = editor;

  editor.insertData = (dataTransfer) => {
    const text = dataTransfer.getData('text/plain');
    const { files } = dataTransfer;

    if (!text && files && files.length > 0) {
      const injectedPlugins = getInjectedPlugins(editor, plugin);
      if (
        !pipeInsertDataQuery(injectedPlugins, {
          data: text,
          dataTransfer,
        })
      ) {
        return insertData(dataTransfer);
      }
      const renamedFiles = renameFilesInFilelist(files);
      uploadFiles(editor, renamedFiles);
    } else {
      insertData(dataTransfer);
    }
  };

  const uploadStore = createUploadStore({
    uploads: {},
  });

  editor.cloud = {
    uploadFiles: (files) => {
      uploadFiles(editor, files);
    },
    uploadStore,
    imageFileHandlers: {
      async onStart(img, filename, insert = true) {
        const { height, width } = await getHeightAndWidthFromDataUrl(img.url);
        // Add initial image node into slate editor.
        const node = {
          type: ELEMENT_IMAGE,
          // url: e.id,
          filename,
          bytes: img.size,
          width,
          height,
          maxWidth: width,
          maxHeight: height,
          children: [{ text: '' }],
        };

        if (insert) insertNode(editor, node);

        // Push file data to store to track upload progress in component.
        editor.cloud.uploadStore.set.upload(filename, {
          filename,
          status: 'progress',
          percent: 0.01,
          totalBytes: img.size,
        });
      },
      onProgress(filename, percent) {
        editor.cloud.uploadStore.set.upload(filename, {
          status: 'progress',
          percent,
        });
      },
      onError(filename, message) {
        const upload = {
          status: 'error',
          message,
        };
        if (message) {
          editor.errorHandler?.pushErrorMessage(message);
        } else {
          editor.errorHandler?.pushErrorMessage(`
            Something went wrong with this image.
            Please try again.
          `);
        }
        editor.cloud.uploadStore.set.upload(filename, upload);
      },
      onSuccess(img, filename, url) {
        const upload = {
          status: 'success',
          url,
        };
        editor.cloud.uploadStore.set.upload(filename, upload);
      },
    },
  };

  return editor;
};
